import {
    TargetsAndGrid,
    RangeLineChart,
    StackedLineBarChart,
} from "@assets/beats/solutions";

export const metaDataHeader = { title: "", desc: "", img: "" };

export const latest = [
    {
        title: "London Climate Action Week event highlights innovation in policy and finance for tropical forests.",
        date: "07.09.25",
        link: "/news/event-recap-lcaw-2025-84",
    },
    {
        title: "CTrees presents on alerts for jurisdictional monitoring at AGU24",
        date: "12.11.24",
        link: "/news/AGU24",
    },
    {
        title: "CTrees hosts panel on jurisdictional finance at Climate Week NYC",
        date: "9.24.24",
        link: "/news/nycw2024-ctreespanel",
    },
];

export const hero = {
    title: "Carbon Markets",
    subheader:
        "Scientific data and insights to accelerate private investment in natural climate solutions",
    bgImg: "https://ctrees-website.s3.amazonaws.com/webv3/solutions/hero/carbon-markets.png",
    bgImgStyle: "h-screen object-cover",
    bgImgPosition: {
        mobile: " object-[12%]",
        tablet: " object-[-250px]",
        desktop: " object-[-20px]",
    },
};

const chartContainerStyle = "h-4/5 w-4/5 m-auto md:w-3/5";
export const firstBeat = {
    title: "Ensuring high-integrity carbon markets",
    subheader:
        "<p>Scientific data is needed to verify whether nature-based carbon credits are delivering real and additional emission reductions.</p>",
    img: <RangeLineChart className={chartContainerStyle} />,
};
export const secondBeat = {
    title: "Providing independent and science-based data",
    subheader:
        "<p>Backed by peer-reviewed science, CTrees provides geospatial data on historical carbon and land-use activities to assess the feasibility and impact of any nature project.</p>",
    img: <TargetsAndGrid />,
    bg: "https://ctrees-website.s3.amazonaws.com/webv3/solutions/beats/carbon-markets.png",
    textRight: true,
};
export const thirdBeat = {
    title: "Alignment with methodologies",
    subheader:
        "<p>CTrees data can be integrated in MRV systems for credits issued under major carbon market standards – including Verra, Architecture for REDD+ Transactions, and Climate Action Reserve.</p>",
    img: <StackedLineBarChart className={chartContainerStyle} />,
};

export const dataCards = [
    {
        img: "https://ctrees-website.s3.us-west-2.amazonaws.com/news/LCAW25_Photo2.png",
        imgAlt: "",
        title: "Event recap: Delivering durable finance for tropical forests",
        subheader:
            "CTrees event at London Climate Action Week highlights innovations in policy and finance.",
        link: "/news/event-recap-lcaw-2025-84",
        linkDisplayText: "see more",
    },
    {
        img: "https://ctrees-website.s3.us-west-2.amazonaws.com/webv3/landing/25_01+Data+Card_LUCA.png",
        imgAlt: "",
        title: "DMRV Demystified webinar",
        subheader:
            "CTrees’ CEO Sassan Saatchi spoke on the future of DMRV tools for carbon markets.",
        link: "https://events.zoom.us/ejl/Agx-mBcbqpuwTUoKUaHd2VDvBIpMi_p4y-_y_WFifLfEbSgWwswE~A2kYLXw1t7RZk06s-rIYgGvsmhAeyiYig-lnb4g4kC9G-iX4E9-zICZ_0MERP-0D7DX-3UEgRWfA139wuj1R-40Yz80zvyiNrJeQ/home",
        linkDisplayText: "learn more",
    },
    {
        img: "https://ctrees-website.s3.us-west-2.amazonaws.com/news/23_08+Verra+consolidated+REDD.jpg",
        imgAlt: "",
        title: "Providing data for Verra’s REDD+ methodology",
        subheader:
            "CTrees is providing jurisdictional data for the standard’s consolidated REDD+ methodology.",
        link: "/news/ctrees-verra-redd-data-14",
        linkDisplayText: "read more",
    },
    {
        img: "https://ctrees-website.s3.us-west-2.amazonaws.com/webv3/solutions/cards/25_04+NYCW.jpg",
        imgAlt: "",
        title: "Raising ambition for jurisdictional finance",
        subheader:
            "CTrees hosted Gov. Helder Barbalho and science and policy experts for a Climate Week NYC event on jurisdictional REDD",
        link: "/news/nycw2024-ctreespanel-41",
        linkDisplayText: "learn more",
    },
];

export const dataSubheader = "News, insights, and data for carbon markets";
